import React, { useState } from "react";

import { AssessmentAPI } from "@/api/legacy/risk-assessment/AssessmentApi";
import ExportBulk from "@/components/dashboard/ExportBulk";
import HeadSelect from "@/components/table/shared/HeadSelect";
import { useMainStore } from "@/contexts/Store";
import FlexDashboardContent from "@/features/risk-assessment/components/FlexDashboardContent/FlexDashboardContent";

import ViewModuleUsers from "../../../components/dashboard/ViewModuleUsers";
import DashboardHeader from "../../../components/shared/DashboardHeader";
import RADashboardContent from "../components/Dashboard/RADashboardContent";
import FlexDashboardContentWrapper from "../components/FlexDashboardContentWrapper/FlexDashboardContentWrapper";
import RiskAssessmentTabs from "../components/RiskAssessmentTabs";

export default function RADashboardPage() {
  const mainStore = useMainStore();
  const { active_workspace: activeWorkspace } = mainStore.users.user;
  const [selectedAssessmentTemplateId, setSelectedAssessmentTemplateId] =
    useState<number>(0);

  const downloadOverview = (assessmentTemplateId: number) => {
    return AssessmentAPI.downloadOverview(
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      activeWorkspace.id,
      // @ts-expect-error TS(2345) FIXME: Argument of type 'number | null' is not assignable... Remove this comment to see the full error message
      assessmentTemplateId == 0 ? null : assessmentTemplateId,
    );
  };

  const generateAndOpenPDFReportRA = (assessmentTemplateId: number) => {
    if (!activeWorkspace) {
      return;
    }
    return AssessmentAPI.generateAndOpenPDFReportRA(
      activeWorkspace.id,
      // @ts-expect-error TS(2345) FIXME: Argument of type 'number | null' is not assignable... Remove this comment to see the full error message
      assessmentTemplateId == 0 ? null : assessmentTemplateId,
    );
  };

  return (
    <FlexDashboardContent>
      <DashboardHeader
        title="Overview"
        LeftActionBar={<ViewModuleUsers />}
        RightActionBar={<HeadSelect />}
      />
      <FlexDashboardContentWrapper
        ModuleHeaderContent={
          <RiskAssessmentTabs
            RightActionBar={
              <ExportBulk
                customTableExportFunction={() =>
                  downloadOverview(selectedAssessmentTemplateId)
                }
                customPDFExportFunction={() =>
                  generateAndOpenPDFReportRA(selectedAssessmentTemplateId)
                }
                isPDFEnabled
              />
            }
          />
        }
      >
        <RADashboardContent
          onSelectedAssessmentIdChange={setSelectedAssessmentTemplateId}
          selectedAssessmentTemplateId={selectedAssessmentTemplateId}
        />
      </FlexDashboardContentWrapper>
    </FlexDashboardContent>
  );
}
